import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  heading: string;
  content1: string;
  content2: string;
  button1Text: string;
  button2Text: string;
  showWaiting:boolean;
  showBuffering: boolean;
}

@Component({
  selector: 'app-dialog-yes-or-no',
  templateUrl:'dialog-yes-or-no.component.html',

  styles:[`
  .flex-gap {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 30px;
    padding-bottom: 10px;
  }
  .ring{
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
    width:150px;
    height:150px;
    background:transparent;
    border:3px solid #62b9ff;
    border-radius:50%;
    text-align:center;
    line-height:150px;
    font-family:sans-serif;
    font-size:20px;
    color:#00569d;
    letter-spacing:4px;
    text-transform:uppercase;
    text-shadow:0 0 10px #00569d;
    box-shadow:0 0 20px #00569d;
  }
  .ring:before
  {
    content:'';
    position:absolute;
    top:-3px;
    left:-3px;
    width:100%;
    height:100%;
    border:3px solid transparent;
    border-top:3px solid #00569d;
    border-right:3px solid #00569d;
    border-radius:50%;
    animation:animateC 2s linear infinite;
  }
  span
  {
    display:block;
    position:absolute;
    top:calc(50% - 2px);
    left:50%;
    width:50%;
    height:4px;
    background:transparent;
    transform-origin:left;
    animation:animate 2s linear infinite;
  }
  span:before
  {
    content:'';
    position:absolute;
    width:16px;
    height:16px;
    border-radius:50%;
    background:#00569d;
    top:-6px;
    right:-8px;
    box-shadow:0 0 20px #00569d;
  }
  @keyframes animateC
  {
    0%
    {
      transform:rotate(0deg);
    }
    100%
    {
      transform:rotate(360deg);
    }
  }
  @keyframes animate
  {
    0%
    {
      transform:rotate(45deg);
    }
    100%
    {
      transform:rotate(405deg);
    }
  }
  `]
})

export class OpenDialogYesOrNo {

  constructor(
    public dialogRef: MatDialogRef<OpenDialogYesOrNo>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

    onNo(): void {
    this.dialogRef.close("close");
  }
  onYes(): void {
    this.dialogRef.close("dontClose");
  }

}